export function extendedCards() {
  if (document.getElementsByClassName("extended-cards")) {
    // set height to tallest card

    // const cards = document.querySelectorAll(
    //   ".extended-cards .extended-card-inner"
    // );
    // let hiddenHeight = 0;
    // let shownHeight = 0;
    // const shownText = document.querySelectorAll(".extended-cards .shown-text");
    // const hiddenText = document.querySelectorAll(
    //   ".extended-cards .hidden-text"
    // );

    // // get tallest hidden text height
    // hiddenText.forEach(function (text) {
    //   console.log(text.clientHeight);
    //   if (text.clientHeight > hiddenHeight) {
    //     hiddenHeight = text.clientHeight;
    //   }
    // });

    // // get tallest shown text height
    // shownText.forEach(function (text) {
    //   if (text.clientHeight > hiddenHeight) {
    //     shownHeight = text.clientHeight;
    //   }
    // });

    // console.log(hiddenHeight);

    // // cards.forEach(function (card) {
    // //   console.log(hiddenText);
    // //   if (card.clientHeight > tallest) {
    // //     tallest = card.clientHeight + 48;
    // //   }
    // // });
    // cards.forEach(function (card) {
    //   card.style.height = shownHeight + hiddenHeight + 48 + "px";
    // });

    // // // set height to tallest card on resize
    // // window.addEventListener("resize", function () {
    // //   cards.forEach(function (card) {
    // //     card.style.height = "auto";
    // //   });

    // //   cards.forEach(function (card) {
    // //     if (card.clientHeight > tallest) {
    // //       tallest = card.clientHeight;
    // //     }
    // //   });
    // //   cards.forEach(function (card) {
    // //     card.style.height = tallest + "px";
    // //   });
    // // });
    // if (hiddenHeight != 0 && shownHeight != 0) {
    answers();
    // }
    // hide answer

    // // show hidden-text on icon-button click and hide all others
    // var buttons = document.querySelectorAll(".show-icon-button");
    // buttons.forEach(function (button) {
    //   button.addEventListener("click", function () {
    //     console.log("click");

    //     const index = this.getAttribute("data-index");
    //     if ((document.getElementById(`loop-${index}`).style.opacity = "1")) {
    //       // answers.forEach(function (answer) {
    //       //   answer.style.opacity = "0";
    //       //   answer.style.height = "0";
    //       // });
    //       console.log("this one is open");
    //     }
    //     if ((document.getElementById(`loop-${index}`).style.opacity = "0")) {
    //       answers.forEach(function (answer) {
    //         answer.style.opacity = "0";
    //         answer.style.height = "0";
    //       });
    //       document.getElementById(`loop-${index}`).style.opacity = "1";
    //       document.getElementById(`loop-${index}`).style.height = "auto";
    //     }
    //   });
    // });

    const buttons = document.querySelectorAll(".show-icon-button");

    buttons.forEach((button) => {
      button.addEventListener("click", function () {
        console.log("click");
        const targetSelector = this.dataset.target;
        const parent = this.closest(".extended-card-inner");
        const allParents = document.querySelectorAll(".extended-card-inner");
        const targetElement = this.closest(
          ".extended-card-inner"
        ).querySelector(targetSelector); // Target within the same card

        // Hide all other visible hidden texts
        document.querySelectorAll(".hidden-text").forEach((el) => {
          if (el !== targetElement && el.style.opacity === "1") {
            el.style.opacity = "0";
            el.style.height = "0";
            el.style.marginTop = "0";
            allParents.forEach((p) => {
              p.style.backgroundColor = "#f5f5f5";
            });
            // allParents.forEach().style.backgroundColor = "#f5f5f5";
          }
        });

        // Toggle the target element
        if (targetElement.style.opacity === "1") {
          targetElement.style.opacity = "0";
          targetElement.style.height = "0";
          targetElement.style.marginTop = "0";
          parent.style.backgroundColor = "#f5f5f5";
        } else {
          targetElement.style.opacity = "1";
          targetElement.style.height = "auto";
          targetElement.style.marginTop = "1rem";
          parent.style.backgroundColor = "#fff";
        }
      });
    });
  }
}

function answers() {
  const answers = document.querySelectorAll(".hidden-text");
  answers.forEach(function (answer) {
    answer.style.opacity = "0";
    answer.style.height = "0";
    answer.style.marginTop = "0";
  });
}
